import styled from 'styled-components';
export const DetailsPageLoaderWrapper = styled.div(
  props => `

.dl_Container{
    margin: 0 auto;
    width: 1200px;
}

.dlLoader *{
    animation: Gradient 3s ease infinite;
}

.hotelDetailsWrapper{
    background:#fff;
    padding-top:30px;
}
.hotelDetailsWrapperInner{
      
      padding-top:30px;
}
.dl_breadcrumb{
    display: flex;
}

.makeFlex{
    display:flex;
    justify-content: space-between;
}

.appendBottom30{
    margin-bottom:30px;
}

.dl_breadcrumb li{
    width: 120px;
    height: 10px;
    margin-right: 30px;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);
    background-size: 800px 104px;
    position: relative;
}
.dl_breadcrumb li:after{
    border: solid #efefef;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    content: "";
    position: absolute;
    right: -15px;
    top: 1px;
}
.dl_breadcrumb li:last-child:after{
    content: none;
}

.dl_left{
    width: 520px;
    height: 350px;
    flex-shrink: 0;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);
    background-size: 800px 104px;
    position: relative;
}
.dl_middle{
    width: 340px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.dl_video{
    height: 190px;
    margin-bottom: 15px;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);
    background-size: 800px 104px;
    position: relative;
}
.dl_map{
    display: flex;
    justify-content: space-between;
    flex: 1;
}
.dl_map_left{
    height: 68px;
    width: 132px;
    margin-right: 15px;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);
    background-size: 800px 104px;
    position: relative;
}
.dl_map_Right{
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: space-between;
    height: 68px;
    width: 132px
}
.dl_map_top{
    height: 65px;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);
    background-size: 800px 104px;
    position: relative;
}
.dl_map_bottom{
    height: 65px;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);
    background-size: 800px 104px;
    position: relative;
}
.dl_right{
    width: 310px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.dl_right_top{
    height: 190px;
    margin-bottom: 15px;
    padding: 15px;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);
    background-size: 800px 104px;
    position: relative;
}
.dl_right_top p{
    height: 10px;
    margin-bottom: 15px;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);
    background-size: 800px 104px;
    position: relative;
}
.dl_right_top p:last-child{
    margin-bottom: 0;
}
.dl_right_bottom{
    flex: 1;
    padding: 15px;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);
    background-size: 800px 104px;
    position: relative;
}
.dl_right_bottom p{
    height: 10px;
    margin-bottom: 15px;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);
    background-size: 800px 104px;
    position: relative;
}
.dl_right_bottom p:last-child{
    margin-bottom: 0;
}

.dl_hotelName{
    width:80%;
}

.dl_hotelName h4{
    height: 20px;
    width: 50%;
    margin-bottom: 10px;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);
    background-size: 800px 104px;
    position: relative;
}
.dl_hotelName p{
    height: 10px;
    width: 30%;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);
    background-size: 800px 104px;
    position: relative;
}
.dl_hotelDetails{
    display: flex;
}
.dl_hotelDetails p{
    height: 10px;
    width: 70%;
    margin-right: 15px;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);
    background-size: 800px 104px;
    position: relative;
}
.dl_hotelDetails span{
    height: 10px;
    width: 80px;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);
    background-size: 800px 104px;
    position: relative;
}

.dl_Section{
    height: 50px;
    border-top:1px #efefef solid;
    border-bottom:1px #efefef solid;
  
}

.dl_SectionInner{
    display: flex;
    align-items: center;
}

.dl_SectionInner span{
    width: 100px;
    margin-top:10px;
    margin-right: 30px;
    height: 20px;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);
    background-size: 800px 104px;
    position: relative;
}

.dl_List{
    display: flex;
    background: #fff;
    width: 100%;
    padding: 10px;
}
.dl_List li{
    display: flex;
    width: 170px;
    margin-right: 10px;
    border: 1px #efefef solid;
    border-radius: 4px;
    height: 50px;
    align-items: center;
    padding: 0 15px;
}
.dl_List li span:first-child{
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    margin-right: 10px;
    border: 1px #efefef solid;
    border-radius: 4px;
}
.dl_List li span:last-child{
    flex:1;
    height: 10px;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);
    background-size: 800px 104px;
    position: relative;
}
.dl_comboRoom{
    border:1px #d1e5ff solid;
    border-radius: 4px;
    overflow: hidden;
    width: 1200px;
    margin: 0 auto;
}
.dl_comboRoom_top{
    border-bottom:1px #d1e5ff solid;
    background: #d1e5ff;
    display: flex;
}
.dl_comboRoom_top > div{
    flex: 1;
    border-right:1px #d1e5ff solid;
    padding: 20px;
    display: flex;
    align-items: center;
}
.dl_comboRoom_top > div:last-child{
    border-right: 0;
}
.dl_comboRoom_top > div span{
    width: 150px;
    height: 10px;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);
    background-size: 800px 104px;
    position: relative;
}

.dl_comboRoom_bottom{
    display: flex;
}
.dl_comboRoom_bottom > div{
    flex: 1;
    height: 200px;
    border-right:1px #d1e5ff solid;
    flex-shrink: 0;
    padding: 20px;
    display: flex;
    flex-direction: column;
    background:#fff;
}
.dl_comboRoom_bottom > div h4{
    height: 20px;
    margin-bottom: 15px;
}
.dl_comboRoom_bottom > div:last-child{
    border-right: 0;
}
.dl_ImgCont{
    display: flex;
    flex: 1;
    height: 150px;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);
    background-size: 800px 104px;
    position: relative;
}
.dl_comboRoom_bottom > div p{
    height: 10px;
    margin-bottom: 15px;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);
    background-size: 800px 104px;
    position: relative;
}
.dl_comboRoom_bottom > div p:last-child{
    margin-bottom: 0;
}

.dl_roomFiltersContainer{
    margin-top:20px;
}

`,
);
